import { useState } from "react";
import { AppHeader } from "@/components/AppHeader";
import { MobileNavigation } from "@/components/MobileNavigation";
import { BRAND, LAYOUT } from "@/lib/designTokens";
import { useCoachPendingAction } from "@/hooks/useCoachPendingAction";

export const Shell = ({ children, onUploadClick }) => {
  const [mobileNavOpen, setMobileNavOpen] = useState(false);
  const { pendingCount: coachPendingCount } = useCoachPendingAction();

  return (
    <div className="app-shell min-h-screen text-dark-text-primary">
      <div className="app-shell-main min-w-0 flex flex-col min-h-screen">
        <AppHeader
          onUploadClick={onUploadClick}
          onOpenMobileNav={() => setMobileNavOpen(true)}
        />

        <main
          id="app-main"
          className="app-main-content flex-1 w-full max-w-[var(--app-content-max)] mx-auto px-4 sm:px-6 lg:px-8 py-6 sm:py-8 lg:py-10 min-w-0"
        >
          {children}
        </main>

        <footer className="app-footer mt-auto">
          <div className="max-w-[var(--app-content-max)] mx-auto px-4 sm:px-6 lg:px-8 py-5 text-[11px] text-dark-text-muted flex flex-col gap-2 sm:flex-row sm:justify-between">
            <span className="uppercase tracking-[0.16em]">
              {BRAND.productName} · v{LAYOUT.appVersion}
            </span>
            <span>Measured data first</span>
          </div>
        </footer>
      </div>

      <MobileNavigation
        open={mobileNavOpen}
        onOpenChange={setMobileNavOpen}
        onUploadClick={onUploadClick}
        coachPendingCount={coachPendingCount}
      />
    </div>
  );
};
